import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";

const MainNavBarConnectionStatus: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { isOnline, isNativeApp } = rootStore.commonStore;
  const { isDownloadInProgress } = rootStore.offlineStore;

  return (
    <>
      {isNativeApp ? (
        <span className="fa-stack fa-lg text-white">
          {isDownloadInProgress ? (
            <i className="fas fa-spinner fa-spin fa-stack-1x"></i>
          ) : (
            <>
              <i className="fas fa-cloud fa-stack-1x"></i>
              {!isOnline && (
                <i className="fas fa-slash fa-stack-1x text-dark"></i>
              )}
            </>
          )}
        </span>
      ) : (
        <></>
      )}
    </>
  );
};

export default observer(MainNavBarConnectionStatus);
